import { render, staticRenderFns } from "./ColumnsSelect.vue?vue&type=template&id=aa644500&scoped=true&"
import script from "./ColumnsSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./ColumnsSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ColumnsSelect.vue?vue&type=style&index=0&id=aa644500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa644500",
  null
  
)

export default component.exports